
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 2C6.478 2 2 6.478 2 12c.001 5.522 4.478 10 10 10s9.999-4.478 9.999-10S17.522 2 12 2zm-.68 16.493c.19.19.426.284.71.284a.965.965 0 00.712-.284.965.965 0 00.284-.711v-.768c.873-.162 1.58-.512 2.12-1.053.54-.54.81-1.214.81-2.02 0-1.45-.881-2.375-2.645-2.773l-1.621-.356c-.418-.094-.707-.204-.868-.327a.62.62 0 01-.228-.483c0-.285.133-.517.399-.697.274-.18.663-.27 1.166-.27.417 0 .758.033 1.024.1.265.056.512.132.74.227.37.151.673.175.91.07a.96.96 0 00.512-.525c.095-.247.104-.498.028-.754-.066-.266-.237-.474-.512-.626a3.397 3.397 0 00-.882-.384 7.2 7.2 0 00-.953-.213v-.712a.965.965 0 00-.284-.71.965.965 0 00-.711-.285.965.965 0 00-.711.284.992.992 0 00-.27.711v.768c-.901.171-1.622.536-2.162 1.096-.531.55-.797 1.223-.797 2.02 0 1.497.872 2.44 2.617 2.83l1.607.341c.427.095.72.213.882.356a.62.62 0 01.242.497c0 .228-.119.427-.356.598-.237.16-.65.242-1.237.242-.579 0-1.057-.057-1.437-.171a5.678 5.678 0 01-.853-.313c-.284-.123-.536-.152-.754-.085a.924.924 0 00-.512.355c-.133.18-.213.384-.242.612a1.26 1.26 0 00.114.64c.104.199.28.355.526.47.256.122.579.246.968.369.398.114.862.194 1.393.242v.697c0 .284.09.521.27.71z","fill":"#282E3E"}})])
          )
        }
      }
    